var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{attrs:{"clearable":"","placeholder":'请输入' + _vm.config.cnName},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }